import React from 'react';
import { spaces } from '../../assets/styles/themes/tokens';
import { Box, SxProps, Typography } from '@mui/material';

interface PageHeaderProps {
  text: string;
  subtext?: string;
  sx?: SxProps;
}

const PageHeader: React.FC<PageHeaderProps> = ({ text, subtext, sx }) => {
  return <Box sx={{
    paddingY: spaces.md,
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    ...sx
  }}>
    <Typography variant='h6'>{text}</Typography>
    {subtext !== undefined && <Typography variant='subtitle2'>•</Typography>}
    {subtext !== undefined && <Typography variant='subtitle2' color='text.secondary'>{subtext}</Typography>}
  </Box>; 
};

export default PageHeader;
